<template>
  <div
    class="vc-section vc-card vc-card--compact vc-customer-params"
    :class="{ 'vc-customer-params--collapsed': !expanded }"
  >
    <div
      class="vc-customer-params__head"
      role="button"
      tabindex="0"
      :title="expanded ? '收起' : '展开'"
      @click="toggleExpanded"
      @keyup.enter="toggleExpanded"
    >
      <span class="vc-customer-params__title">客户信息参数</span>
      <span class="vc-customer-params__chevron">
        <Icon :type="expanded ? 'ios-arrow-up' : 'ios-arrow-down'" size="18" />
      </span>
    </div>
    <div v-show="expanded" class="vc-customer-params__body">
      <div class="vc-param-toolbar">
        <span class="vc-param-meta">{{ customerInfoParamCount }}/{{ maxCustomerInfoParams }}</span>
        <AddParamLinkButton
          :disabled="customerInfoParamCount >= maxCustomerInfoParams"
          @click.stop="addCustomerInfoParamRow"
        />
      </div>
      <div class="vc-param-table-head">
        <span class="vc-param-drag-col" />
        <span class="vc-param-key-col">参数Key</span>
        <span class="vc-param-name-col">参数值</span>
        <span class="vc-param-del-col" />
      </div>
      <draggable
        v-model="customerInfoParams"
        handle=".vc-param-drag"
        class="vc-param-list"
        :animation="180"
      >
        <div
          v-for="(row, index) in customerInfoParams"
          :key="'cip-' + index"
          class="vc-param-row"
        >
          <span class="vc-param-drag"><Icon type="md-menu" size="20" /></span>
          <Input v-model="row.paramKey" class="vc-param-input-key" placeholder="{key}" />
          <Input v-model="row.paramName" class="vc-param-input-name" placeholder="请输入参数值" />
          <Poptip
            :value="exclusiveConfirmKey === 'customer-param-' + index"
            confirm
            placement="top-end"
            transfer
            :title="customerInfoParamDeleteTitle(row)"
            ok-text="确定"
            cancel-text="取消"
            @click.native.stop
            @input="onExclusiveConfirmInput('customer-param-' + index, $event)"
            @on-ok="removeCustomerInfoParamRow(index)"
          >
            <span class="vc-param-del-trigger">
              <DeleteIconButton size="sm" title="删除" />
            </span>
          </Poptip>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DeleteIconButton from '../shared/DeleteIconButton.vue'
import AddParamLinkButton from '../shared/AddParamLinkButton.vue'
import { exclusiveConfirmMixin } from '../../utils/exclusiveConfirm'

const MAX_CUSTOMER_INFO_PARAMS = 15

export default {
  name: 'LlmCustomerInfoParamsSection',
  mixins: [exclusiveConfirmMixin],
  components: { draggable, DeleteIconButton, AddParamLinkButton },
  props: {
    customerInfoParams: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
      maxCustomerInfoParams: MAX_CUSTOMER_INFO_PARAMS,
    }
  },
  computed: {
    customerInfoParamCount() {
      return (this.customerInfoParams && this.customerInfoParams.length) || 0
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
    },
    addCustomerInfoParamRow() {
      if (this.customerInfoParamCount >= this.maxCustomerInfoParams) return
      this.customerInfoParams.push({ paramName: '', paramKey: '' })
    },
    removeCustomerInfoParamRow(index) {
      this.closeExclusiveConfirm('customer-param-' + index)
      this.customerInfoParams.splice(index, 1)
    },
    customerInfoParamDeleteTitle(row) {
      if (!row) return '确定要删除该参数吗？'
      const n = row.paramName != null ? String(row.paramName).trim() : ''
      const k = row.paramKey != null ? String(row.paramKey).trim() : ''
      if (n) return `确定删除参数「${n}」吗？`
      if (k) return `确定删除参数「${k}」吗？`
      return '确定要删除该参数吗？'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../voice-call/shared.scss';

.vc-section {
  margin-bottom: 16px;
}

.vc-card {
  background: #fff;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  padding: 20px;
}

.vc-card--compact {
  padding-bottom: 16px;
}

.vc-customer-params {
  text-align: left;
}

.vc-customer-params--collapsed {
  padding-bottom: 20px;

  .vc-customer-params__head {
    margin-bottom: 0;
  }
}

.vc-customer-params__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  min-height: 24px;
  cursor: pointer;
  user-select: none;
}

.vc-customer-params__title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  line-height: 24px;
}

.vc-customer-params__chevron {
  display: inline-flex;
  align-items: center;
  color: #3e3e3e;
  flex-shrink: 0;
}

.vc-param-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}

.vc-param-meta {
  font-size: 13px;
  color: #8c8c8c;
}

.vc-param-table-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0 10px;
  font-size: 12px;
  font-weight: 600;
  color: #595959;
  border-bottom: 1px solid #f0f0f0;

  .vc-param-name-col,
  .vc-param-key-col {
    text-align: left;
  }
}

.vc-param-drag-col {
  width: 28px;
}

.vc-param-name-col,
.vc-param-key-col {
  flex: 1;
  min-width: 0;
}

.vc-param-del-col {
  width: 36px;
}

.vc-param-list {
  padding-top: 8px;
}

.vc-param-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.vc-param-drag {
  width: 28px;
  text-align: center;
  cursor: grab;
  color: #bfbfbf;

  &:active {
    cursor: grabbing;
  }
}

.vc-param-input-name,
.vc-param-input-key {
  flex: 1;
  min-width: 0;
}

.vc-param-del-trigger {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  outline: none;
}
</style>
